import { liveVoiceErrorMessage } from './liveVoiceErrorConfig';
/**
 * 指挥端：按队员批量开关语音对讲门禁（allow_voice_ptt）
 * POST /api/tracker/voice-ptt/allow
 * 结束任务清理：POST /api/tracker/voice-ptt/mission-cleanup
 */
import apiFetch from '../apiFetch';

export async function setMissionVoicePttAllow({ allow, deviceUniqueIds = [], names = [] }) {
  const device_unique_ids = (deviceUniqueIds || []).map((x) => String(x || '').trim()).filter(Boolean);
  const nameList = (names || []).map((x) => String(x || '').trim()).filter(Boolean);
  if (!device_unique_ids.length && !nameList.length) {
    return { success: true, updated_count: 0, skipped: true };
  }
  const res = await apiFetch('/api/tracker/voice-ptt/allow', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      allow: Boolean(allow),
      device_unique_ids,
      names: nameList
    })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    const err = new Error(data.error || data.message || `HTTP ${res.status}`);
    err.code = data.code;
    err.status = res.status;
    throw err;
  }
  if (!data.skipped && Number(data.updated_count || 0) === 0) {
    const err = new Error(data.error || liveVoiceErrorMessage('VOICE_PTT_ALLOW_NO_MATCH'));
    err.code = 'voice_ptt_allow_no_match';
    err.status = 409;
    err.data = data;
    throw err;
  }
  return data;
}

/**
 * 结束任务：清理语音会话 + 上行 audio 媒体 + 对话软删；不删队员轨迹。
 */
export async function cleanupMissionVoiceJunk({ deviceUniqueIds = [], names = [], missionId = null } = {}) {
  const device_unique_ids = (deviceUniqueIds || []).map((x) => String(x || '').trim()).filter(Boolean);
  const nameList = (names || []).map((x) => String(x || '').trim()).filter(Boolean);
  if (!device_unique_ids.length && !nameList.length) {
    return { success: true, skipped: true, tracks_kept: true };
  }
  const body = { device_unique_ids, names: nameList };
  if (missionId) body.mission_id = String(missionId).trim();
  const res = await apiFetch('/api/tracker/voice-ptt/mission-cleanup', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    const err = new Error(data.error || data.message || `HTTP ${res.status}`);
    err.code = data.code;
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

/** 从队员对象收集 device_unique_id / name（二者都传，避免 Locus id 与令牌 name 不一致时只打空） */
export function collectVoicePttTargets(members = []) {
  const deviceUniqueIds = [];
  const names = [];
  const seenId = new Set();
  const seenName = new Set();
  (members || []).forEach((m) => {
    const id = m?.device_unique_id ? String(m.device_unique_id).trim() : '';
    const name = m?.name ? String(m.name).trim() : '';
    if (id && !seenId.has(id)) { seenId.add(id); deviceUniqueIds.push(id); }
    if (name && !seenName.has(name)) { seenName.add(name); names.push(name); }
  });
  return { deviceUniqueIds, names };
}